import { ref, onMounted } from 'vue';
import { useAnalytics } from './useAnalytics';
export function useCookieConsent() {
    const showConsentModal = ref(false);
    const showInfoModal = ref(false);
    const { initAnalyticsOnAccept } = useAnalytics();
    const analyticsLoaded = ref(false);
    onMounted(() => {
        const hasConsent = localStorage.getItem('cookieConsent');
        if (!hasConsent) {
            showConsentModal.value = true;
        }
        else if (hasConsent === 'all' && !analyticsLoaded.value) {
            initAnalyticsOnAccept();
            analyticsLoaded.value = true;
        }
    });
    const acceptAllCookies = () => {
        localStorage.setItem('cookieConsent', 'all');
        showConsentModal.value = false;
        if (!analyticsLoaded.value) {
            initAnalyticsOnAccept();
            analyticsLoaded.value = true;
        }
    };
    const acceptNecessaryOnly = () => {
        localStorage.setItem('cookieConsent', 'necessary');
        showConsentModal.value = false;
    };
    const showCookieInfo = () => {
        showInfoModal.value = true;
    };
    const hideCookieInfo = () => {
        showInfoModal.value = false;
    };
    return {
        showConsentModal,
        showInfoModal,
        acceptAllCookies,
        acceptNecessaryOnly,
        showCookieInfo,
        hideCookieInfo
    };
}
